import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { articles } from '../../data/library';
import { Eyebrow } from '../ui/Eyebrow';
export function LibraryPreview() {
  const featured = articles.slice(0, 5);
  return <section className="bg-cream-deep" aria-labelledby="library-heading" data-id="element-199" data-mp="su09dgwyei4f">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-200" data-mp="xo4gq1a4ss61">
        <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20" data-id="element-201" data-mp="11n4wtc185gpc">
          <div data-id="element-202" data-mp="16mzoviwqkcbz">
            <Eyebrow className="text-brick" data-id="element-203" data-mp="16mgfwrp2cya3">The unanswered questions</Eyebrow>
            <h2 id="library-heading" className="mt-5 max-w-sm font-serif text-4xl leading-[1.05] text-ink md:text-[3.25rem]" data-id="element-204" data-mp="1bmm2htgh7ulb">
              The things you typed at 3am.
            </h2>
            <p className="mt-6 max-w-sm leading-relaxed text-ink-soft" data-id="element-205" data-mp="3der1tq0b1u62">
              Every piece is titled as the question you actually asked, reviewed by a named
              clinician, dated, and ends with what the evidence genuinely does not settle. None of
              it is behind an email address.
            </p>
            <Link to="/library" className="group mt-8 inline-flex items-center gap-2 font-serif text-xl text-brick transition-colors duration-150 ease-brand hover:text-brick-deep" data-id="element-206" data-mp="lnike9yg6wfx">
              Read the library
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-brand group-hover:translate-x-1" aria-hidden="true" data-id="element-207" data-mp="19f7gm1ee4525" />
            </Link>
          </div>

          <ul data-id="element-208" data-mp="zfglbxi09m10">
            {featured.map(article => <li key={article.slug} className="rule" data-id="element-209" data-mp="vewmmphsaacr">
                <Link to={`/library/${article.slug}`} className="group flex items-start justify-between gap-8 py-7" data-id="element-210" data-mp="ved3x6kb7hxo">
                  <div data-id="element-211" data-mp="3g4vrgq3j83b5">
                    <h3 className="font-serif text-2xl leading-snug text-ink transition-colors duration-150 ease-brand group-hover:text-brick md:text-[1.875rem]" data-id="element-212" data-mp="3g3kd5wcgnd5s">
                      {article.question}
                    </h3>
                    <p className="mt-3 max-w-xl leading-relaxed text-ink-soft" data-id="element-213" data-mp="3mj1cyh41t4lg">
                      {article.standfirst}
                    </p>
                    <p className="mt-3 text-sm text-ink-muted" data-id="element-214" data-mp="3cmeq5ms5w3gs">
                      {article.readMinutes} min · Reviewed by {article.reviewedBy}
                    </p>
                  </div>
                  <ArrowRightIcon className="mt-2 h-5 w-5 shrink-0 text-brick transition-transform duration-150 ease-brand group-hover:translate-x-1" aria-hidden="true" data-id="element-215" data-mp="33mrpx4b653pb" />
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}